<template>
  <div
    class="audio-item-refer-box"
    :class="`audio-item-refer-box-${createRenderType}`"
    ref="referMusicItem"
    :data-refer-id="props.item?.id"
  >
    <AudioPlayer
      ref="refPlayer"
      :url="`${getObjectStorageFullUrl(props.item.url)}${
        props.audioUrlSuffix
      }&id=${props.item.id}`"
      :duration="renderData.duration"
      @syncDuration="syncDuration"
      @syncPlayState="syncPlayState"
      @syncLoadingState="syncLoadingState"
      @syncProgress="syncProgress"
    >
      <div
        class="audio-item-refer"
        :class="{
          active: renderData.isCurPlay,
        }"
        @click.stop="
          () => {
            if (renderData.curUseReferMusic?.id != props.item?.id) {
              doApply();
            } else {
              doCancel();
            }
          }
        "
      >
        <div class="audio-item-refer-op-box fn-inline pointer">
          <LoaderProgressCircle
            :size="createRenderType == 'mobile' ? 40 : 40"
            :default-color="
              renderData.isplay || renderData.isCurPlay
                ? 'rgba(255,255,255,0.2)'
                : 'rgba(255,255,255,1)'
            "
            progress-color="#94ADFF"
            :progress="renderData.progress / 100"
          >
            <div
              class="audio-item-refer-op flex-center"
              @click.stop="doTogglePlay"
            >
              <i
                class="block"
                :class="{
                  'isplay-true': renderData.isplay,
                  'isplay-false': !renderData.isplay,
                }"
              ></i>
            </div>
          </LoaderProgressCircle>
        </div>
        <div class="audio-item-refer-info flex1 width-0">
          <div class="audio-item-refer-title-tag">
            <div
              class="audio-item-refer-title olh"
              v-if="!renderData.isEditTitle"
            >
              {{ formatName(renderData.title ?? "") }}
            </div>
            <div
              class="audio-item-refer-tag"
              v-if="props.item?.genre && !renderData.isEditTitle"
            >
              {{ formatTag(props.item?.genre, ReferStyleLabelData) }}
            </div>
            <div
              class="audio-item-refer-tag"
              v-if="props.item?.mood && !renderData.isEditTitle"
            >
              {{ formatTag(props.item?.mood, ReferEmotionalLabelData) }}
            </div>

            <div class="audio-item-edit" v-if="renderData.isEditTitle">
              <input
                @click.stop
                ref="refInput"
                :value="renderData.title"
                @input="onInput"
                @blur.native="onBlur"
                placeholder="Enter title..."
                @compositionstart="handleCompositionStart"
                @compositionend="handleCompositionEnd"
              />
            </div>
          </div>
          <div class="audio-item-refer-decription olh">
            {{
              `${
                props.hideFrom
                  ? ""
                  : `${$$t("create.from_user").replace(
                      "[user_name]",
                      props.item?.username
                    )} · `
              }${mediaUtils.formatTime(
                renderData.isCurPlay
                  ? (renderData.duration * (100 - renderData.progress)) / 100
                  : renderData.duration
              )}`
            }}
          </div>
        </div>
        <!-- <div
          class="audio-item-playing-wave flex-center"
          v-if="renderData.isplay"
        >
          <LoaderWave :animation="renderData.isplay"></LoaderWave>
        </div> -->
        <div class="audio-item-btn audio-item-refer-btn1">
          <Button
            v-if="renderData.curUseReferMusic?.id != props.item?.id"
            @click.stop="doApply"
            :renderStyle="{
              '--padding': '0 15px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(255, 255, 255, 0.1)', //#94ADFF
              '--fontColor': '#fff',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(255, 255, 255, 0.2)',
              '--fontColor': '#fff',
            }"
          >
            {{ $$t("create.use") }}
          </Button>
          <Button
            v-if="renderData.curUseReferMusic?.id == props.item?.id"
            @click.stop="doCancel"
            :renderStyle="{
              '--padding': '0 15px',
              '--width': 'max-content',
              '--height': '32px',
              '--borderRadius': '50px',
              '--background': 'rgba(148, 173, 255, 1)',
              '--fontColor': '#000',
              '--fontSize': '14px',
              '--fontWeight': 'normal',
              '--border': 'none',
              '--backgroundHover': 'rgba(148, 173, 255, 0.8)',
              '--fontColorHover': '#000',
            }"
          >
            {{ $$t("create.cancel") }}
          </Button>
        </div>
        <div
          class="audio-item-ico-btn audio-item-ico-btn-btn2 flex-center"
          @click.stop
          v-if="props.hideFrom && !props.isUsed"
        >
          <IconButton
            size="32px"
            icoSize="26px"
            @onClick="doEditSongTitle"
            :backgroundColor="
              renderData.renderClass == 'drawer-dialog'
                ? 'rgba(255, 255, 255, 0.1)'
                : 'rgba(255, 255, 255, 0)'
            "
            :hoverBackgroundColor="
              renderData.renderClass == 'drawer-dialog'
                ? 'rgba(255, 255, 255, 0.15)'
                : 'rgba(255, 255, 255, 0.1)'
            "
          >
            <img src="../../../assets/img/refer-edit-ico.png" />
          </IconButton>
        </div>
        <div
          class="audio-item-ico-btn audio-item-ico-btn-delete flex-center"
          v-if="props.hideFrom"
          @click.stop="doDelete"
        >
          <i class="block"></i>
        </div>
        <div
          class="audio-item-refer-more-box audio-item-ico-btn pointer flex-center"
          @click.stop="doMore"
          @mouseover="calcSetMoreListBoxPosition"
          v-if="globalConfig.appname == chinaAppName && props.tabCode == 1"
        >
          <div
            class="audio-item-refer-more-btn pointer flex-center"
            @click="showMoreDialog"
          >
            <i class="block"></i>
          </div>
          <div
            class="audio-item-refer-more-list-box"
            :class="{
              'position-t': renderData.position == 'top' && props.index > 0,
              'position-b': renderData.position == 'bottom' || props.index <= 0,
            }"
          >
            <div class="audio-item-refer-more-list">
              <!--  <div
                class="audio-item-refer-more-list-item"
                v-if="props.hideFrom"
                @click.stop="doEditSongTitle"
              >
                {{ $$t("create.edit_song_title") }}
              </div>
              <div
                class="audio-item-refer-more-list-item"
                v-if="props.hideFrom"
                @click.stop="doDelete"
              >
                {{ $$t("create.delete") }}
              </div> -->
              <div
                class="audio-item-refer-more-list-item"
                @click.stop="doReport"
              >
                {{ $$t("editor.report") }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </AudioPlayer>
    <ReportDialog
      v-if="renderData.reportDialogVisible"
      v-model:visible="renderData.reportDialogVisible"
      :data="props.item"
      :reportType="3"
    ></ReportDialog>
    <AudioReferItemOpDialog
      v-if="renderData.moreDialogVisible && createRenderType == 'mobile'"
      v-model:visible="renderData.moreDialogVisible"
      :data="props.item"
      @report="doReport"
    >
    </AudioReferItemOpDialog>
  </div>
</template>

<script setup>
import {
  ref,
  defineProps,
  defineEmits,
  computed,
  readonly,
  reactive,
  watch,
  defineExpose,
  onMounted,
  onUpdated,
  onUnmounted,
  getCurrentInstance,
} from "vue";

import globalConfig, {
  chinaAppName,
  ModuleOpenStateControl,
  getPipeReadableFlowUrl,
} from "@/config/config.js";

import { useRouter, useRoute } from "vue-router";
import AudioPlayer from "@/components/media/audioPlayer/AudioPlayer.vue";
import Button from "@/components/basic/button/Button.vue";
import { getObjectStorageFullUrl } from "@/lib/objectStorage/objectStorage.js";
import message from "@/components/functionCallComponent/message.jsx";
import ReportDialog from "@/components/report/reportDialog.vue";
import AudioReferItemOpDialog from "@/page/create/audioReferItemOp/audioReferItemOpDialog.vue";

import mediaUtils from "@/components/media/utils/utils.js";
import tools from "@/utils/tools.js";
import userReferMusicStore from "@/store/create/referMusicStore.js";
import LoaderWave from "@/components/animation/LoaderWave.vue";
import LoaderProgressCircle from "@/components/animation/LoaderProgressCircle.vue";
import {
  ReferEmotionalLabelData,
  ReferStyleLabelData,
} from "@/config/const.js";
import apiReferMusic from "@/api/api/apiReferMusic.js";

import { storeToRefs } from "pinia";
import useCreateLayoutStore from "@/store/create/createLayoutStore.js";
const createLayoutStore = useCreateLayoutStore();
const { createRenderType } = storeToRefs(createLayoutStore);

const referMusicStore = userReferMusicStore();

const Router = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext?.config?.globalProperties?.$router;
const route = useRoute();
const { $$language, $$t, $$tm, $$tValue } =
  getCurrentInstance().appContext?.config.globalProperties.$i18n ?? {};

const appContext = (getCurrentInstance() || window?.$getVueCurrentInstance?.())
  .appContext;

const props = defineProps({
  hideFrom: {
    type: Boolean,
    default: false,
  },
  item: {
    type: Object,
    default: () => {},
  },
  index: {
    type: Number,
    default: 0,
  },
  tabCode: {
    type: Number,
    default: 0,
  },
  audioUrlSuffix: {
    type: String,
    default: "",
  },
});

const referMusicItem = ref(null);
const referPlayerOp = ref(null);
const refPlayer = ref(null);
const refInput = ref(null);
const emits = defineEmits([
  "apply",
  "cancel",
  "more",
  "editSongTitle",
  "delete",
]);
const stateData = {};
const renderData = reactive({
  isCurPlay: false,
  curUseReferMusic: null,
  duration: props.item.duration_milliseconds / 1000,
  isplay: false,
  buffer: false,
  progress: 0,

  title: props.item.title,
  isEditTitle: false,
  position: "bottom",
  reportDialogVisible: false,
});

const calcSetMoreListBoxPosition = () => {
  if (referMusicItem.value) {
    const { top, height } = referMusicItem.value.getBoundingClientRect();
    if (top + height / 2 >= document.body.clientHeight / 2) {
      renderData.position = "top";
    } else {
      renderData.position = "bottom";
    }
  }
};

const formatName = (name) => {
  return name ? name.replace(/(.mp3|.mp4|.wav)$/, "") : "";
};

const formatTag = (tag, type) => {
  let falg = null;
  type.list.forEach((item) => {
    if (item.en == tag) {
      falg = item[$$language()];
    }
  });
  return falg ?? tag;
};

const syncDuration = (duration) => {
  renderData.duration = duration;
};

const syncPlayState = (playState) => {
  renderData.isplay = playState;
};
const syncLoadingState = (loadingState) => {
  renderData.buffer = loadingState;
};
const syncProgress = (progress) => {
  renderData.progress = progress;
};

const doTogglePlay = () => {
  refPlayer.value?.changeOp();
};

const doApply = () => {
  emits("apply", props.item);
};

const doCancel = () => {
  emits("cancel", props.item);
};

const doMore = () => {
  emits("more", props.item);
};

const showMoreDialog = () => {
  renderData.moreDialogVisible = true;
};

const doReport = () => {
  renderData.reportDialogVisible = true;
};

const doEditSongTitle = () => {
  renderData.isEditTitle = true;
  nextTick(() => {
    refInput.value.focus();
  });
};
const handleCompositionStart = () => {
  renderData.inputing = true;
};

const handleCompositionEnd = (e) => {
  renderData.inputing = false;
  onInput(e);
};
const onInput = (e) => {
  if (!renderData.inputing) {
    e.target.value = e.target.value.slice(0, 60);
    const value = e.target.value;
    renderData.title = value;
  }
};
const onBlur = () => {
  if (renderData.title.length > 0) {
    if (renderData.title == props.item.title) {
      renderData.isEditTitle = false;
    } else {
      apiReferMusic
        .saveReferItemTitle({
          id: props.item.id,
          title: renderData.title,
        })
        .then((res) => {
          if (res.code == 200) {
            renderData.isEditTitle = false;
          } else if (res.code == 6316) {
            message.error({
              position: "top",
              content: $$t("create.song_title_audit_failed"),
            });
            renderData.title = props.item.title;
            refInput.value?.focus();
          } else {
            renderData.isEditTitle = false;
            renderData.title = props.item.title;
          }
        })
        .catch(() => {
          renderData.isEditTitle = false;
        });
    }
  } else {
    renderData.isEditTitle = false;
    renderData.title = props.item.title;
  }
};
const doDelete = () => {
  emits("delete", props.item);
};

watch(
  () => {
    return referMusicStore.curUseReferMusic;
  },
  () => {
    renderData.curUseReferMusic = referMusicStore.curUseReferMusic;
  }
);

const changeUrlListenerListener = () => {
  renderData.isCurPlay =
    appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer
      ?.currentUrl ==
    `${getObjectStorageFullUrl(props.item.url)}${props.audioUrlSuffix}&id=${
      props.item.id
    }`;
};
onMounted(() => {
  renderData.curUseReferMusic = referMusicStore.curUseReferMusic;
  renderData.duration = (props.item?.duration_milliseconds || 0) / 1000;
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.registGlobalListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  // console.log("onMounted", props.item);
});

onUnmounted(() => {
  appContext?.config?.globalProperties?.$globalMediaUtils?.globalAudioPlayer?.releaseGlobalListener(
    "curPlayUrlChange",
    changeUrlListenerListener
  );
  // console.log("onMounted", props.item);
});
</script>
<style lang="scss" scope>
.audio-item-refer-box {
  .audio-item-refer {
    display: flex;
    align-items: center;
    padding: 12px 40px 12px 40px;
    &:hover {
      background: rgba(255, 255, 255, 0.1);
    }
    &.active {
      background: rgba(148, 173, 255, 0.2);
      &:hover {
        background: rgba(148, 173, 255, 0.3);
      }
    }
    .audio-item-refer-op {
      width: 100%;
      height: 100%;
      border-radius: 20px;
      /*border: 1px solid #ffffff;*/
      i {
        height: 20px;
        width: 20px;
      }
      .isplay-false {
        background: url("@/assets/img/play-light-ico.png");
        background-size: 100% 100%;
      }
      .isplay-true {
        background: url("@/assets/img/pause-light-ico.png");
        background-size: 100% 100%;
      }
    }
    .audio-item-refer-title-tag {
      display: flex;
      align-items: center;
      .audio-item-refer-title {
        font-family: HarmonyOS Sans SC;
        font-size: 16px;
        font-weight: 500;
        line-height: 24px;
        height: 24px;
        color: #ffffff;
        flex: 0 1 auto;
        max-width: 100%;
      }
      .audio-item-refer-tag {
        height: 14px;
        border-radius: 2px;
        opacity: 0.5;
        padding: 0px 3px;
        box-sizing: border-box;
        border: 1px solid rgba(255, 255, 255, 0.5);
        font-family: HarmonyOS Sans SC;
        font-size: 10px;
        font-weight: normal;
        line-height: 12px;
        letter-spacing: 0em;
        color: rgb(255, 255, 255);
        margin-left: 6px;
        min-width: max-content;
        text-transform: capitalize;
      }

      .audio-item-edit {
        width: 100%;
        height: 24px;
        padding: 1px 6px;
        background: rgba(255, 255, 255, 0.1);
        input {
          height: 24px;
          width: 100%;
          font-family: HarmonyOS Sans SC;
          font-size: 16px;
          font-weight: 500;
          line-height: 20px;
          color: #ffffff;
          background: transparent;
          border: none;
          outline: none;
          color: #ffffff;
          &::placeholder {
            color: rgba(255, 255, 255, 0.5) !important;
          }
        }
      }
    }
    .audio-item-refer-decription {
      margin-top: 4px;
      font-family: HarmonyOS Sans SC;
      font-size: 12px;
      font-weight: normal;
      line-height: 16px;
      height: 16px;
      letter-spacing: 0em;
      color: rgba(255, 255, 255, 0.5);
    }
    .audio-item-playing-wave {
      width: 32px;
      height: 32px;
    }
    .audio-item-refer-ico-btn {
      width: 32px;
      height: 32px;
      i {
        height: 24px;
        width: 24px;
      }
    }
    .audio-item-refer-like-status {
      i.like-true {
        background: url("@/assets/img/like-ico.png");
        background-size: 100% 100%;
      }
      i.like-false {
        background: url("@/assets/img/not-like-ico.png");
        background-size: 100% 100%;
      }
    }
    .audio-item-refer-more-btn {
      height: 32px;
      width: 32px;
      i {
        background: url("@/assets/img/more-ico.png");
        background-size: 100% 100%;
      }
    }
    .audio-item-ico-btn {
      width: 32px;
      height: 32px;
      position: relative;
      margin-left: 12px;
      border-radius: 20px;
      background: rgba(255, 255, 255, 0.1);
      i {
        height: 20px;
        width: 20px;
      }
      &:hover {
        background: rgba(255, 255, 255, 0.2);
      }
      .audio-item-refer-more-list-box {
        position: absolute;
        z-index: 1;
        display: none;
        &.position-t {
          bottom: 20px;
          right: 0;
          padding: 0 0 25px 0;
        }

        &.position-b {
          top: 20px;
          right: 0;
          padding: 25px 0 0 0;
        }
      }
      .audio-item-refer-more-list {
        padding: 0px 0;
        width: 160px;
        border-radius: 8px;
        background: rgba(255, 255, 255, 0.2);
        border: 1px solid rgba(255, 255, 255, 0);
        backdrop-filter: blur(20px);

        .audio-item-refer-more-list-item {
          padding: 0 20px;
          height: 32px;
          font-family: HarmonyOS Sans SC;
          font-size: 14px;
          font-weight: 500;
          line-height: 32px;
          color: #ffffff;
        }
        .audio-item-refer-more-list-item:hover {
          background: rgba(255, 255, 255, 0.1);
        }
      }
      &:hover {
        .audio-item-refer-more-list-box {
          display: block;
        }
      }
      &.audio-item-ico-btn-delete {
        i {
          background: url("@/assets/img/delete-white-ico.png");
          background-size: 100% 100%;
        }
      }
    }
    .audio-item-btn {
      .el-button {
        min-width: 65px;
      }
    }
    .audio-item-refer-info,
    .audio-item-ico-btn,
    .audio-item-refer-like-status,
    .audio-item-refer-more-box {
      margin-left: 8px;
    }
  }

  &.audio-item-refer-box-mobile {
    .audio-item-refer-more-box {
      &:hover {
        .audio-item-refer-more-list-box {
          display: none;
        }
      }
    }
    .audio-item-refer {
      padding: 10px 40px 10px 40px;
      .audio-item-refer-title-tag {
        .audio-item-refer-title {
          font-size: 14px;
          line-height: 20px;
        }
      }
    }
    .audio-item-ico-btn {
      &.audio-item-ico-btn-delete {
        display: flex;
      }
    }
  }
}
</style>
